export function getIsEdge() {
  return navigator.userAgent.indexOf('Edge') > -1
}
